import { isValidElement, ReactElement, ReactNode } from 'react'

import { IRenderWhenProps, RenderWhen } from '../renderWhen'

import {
  ISimpleTableBodyCellProps,
  ISimpleTableBodyRowProps,
  ISimpleTableHeaderCellProps,
  ISimpleTableHeaderRowProps,
} from './models'
import { SimpleTable } from './SimpleTable'

export const isBodyCell = (child: ReactNode): child is ReactElement<ISimpleTableBodyCellProps> => {
  return (
    (isValidElement<ISimpleTableBodyCellProps>(child) && child.type === SimpleTable.BodyCell) ||
    isConditionItem(child)
  )
}

export const isHeaderCell = (
  child: ReactNode
): child is ReactElement<ISimpleTableHeaderCellProps> => {
  return (
    (isValidElement<ISimpleTableHeaderCellProps>(child) && child.type === SimpleTable.HeaderCell) ||
    isConditionItem(child)
  )
}

export const isBodyRow = (child: ReactNode): child is ReactElement<ISimpleTableBodyRowProps> => {
  return isValidElement<ISimpleTableBodyRowProps>(child) && child.type === SimpleTable.BodyRow
}

export const isHeaderRow = (
  child: ReactNode
): child is ReactElement<ISimpleTableHeaderRowProps> => {
  return isValidElement<ISimpleTableHeaderRowProps>(child) && child.type === SimpleTable.HeaderRow
}

export const isConditionItem = (
  child: ReactNode
): child is ReactElement<ISimpleTableHeaderCellProps | ISimpleTableBodyCellProps> => {
  return isValidElement<IRenderWhenProps>(child) && child.type === RenderWhen
}
